module.exports = __webpack_public_path__ + "static/logo-timeout@2x-a197a83168f9bd6f1ea67e156e890e8e.png";